export default __webpack_public_path__ + "static/decoracionEstrella-17a4e87b7e4c83107a75c02935345749.png";